import { Grid, Typography } from '@mui/material';
import { styled } from '@mui/system';
import dayjs from 'dayjs';
import React from 'react';
import { FormulaActivityAttributes } from '../../../services/types/apiType';
import { formattedLabel } from '../utils';

interface FormulaActivityCardProps {
  data: FormulaActivityAttributes;
}
const FormulaActivityCard: React.FC<FormulaActivityCardProps> = ({ data }) => {
  return (
    <GridContainer key={data.id} container spacing={2}>
      <Grid item xs={12}>
        <RowTitle>Khách hàng - Tên màu:</RowTitle> {data.title}
      </Grid>
      <Grid item xs={6}>
        <RowTitle>Máy:</RowTitle> {data.machine}
      </Grid>
      <Grid item xs={6}>
        <RowTitle>Khối lượng (Kg):</RowTitle> {data.quantity}
      </Grid>
      <Grid item xs={6}>
        <RowTitle>Màu sử dụng (G):</RowTitle>{' '}
        {Object.entries(data.colors)
          .map(([name, quantity]) => `${formattedLabel[name as keyof typeof formattedLabel] || name}: ${quantity}`)
          .join('\n')}
      </Grid>
      <Grid item xs={6}>
        <RowTitle>Chất hóa học (Kg):</RowTitle>{' '}
        {Object.entries(data.chemicals)
          .map(([name, quantity]) => `${formattedLabel[name as keyof typeof formattedLabel] || name}: ${quantity}`)
          .join('\n')}
      </Grid>
      <Grid item xs={12}>
        <RowTitle>Thời gian:</RowTitle> {dayjs(data.createdAt).format('HH:mm DD/MM/YYYY')}
      </Grid>
    </GridContainer>
  );
};

const RowTitle = styled(Typography)({
  fontWeight: 500,
});

const GridContainer = styled(Grid)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
  padding: 16,
  whiteSpace: 'pre-line',
  lineHeight: 1.5,
}));

export default FormulaActivityCard;
